import React, { Component } from "react";

class TermsPage extends Component {
  componentWillMount = () => {
    console.log("Mounting Terms");
    this.props.setAppDefault();
  };
  render() {
    return (
      <div
        className="content flex-container"
        style={{
          display:
            this.props.appState.currentPage === "terms" ? "block" : "none",
        }}
      >
        <div
          className="flex-container mt-4 mb-4"
          style={{
            maxHeight: "20rem",
            maxWidth: "30rem",
            overflow: "auto",
            margin: "auto",
            borderStyle: "groove",
          }}
        >
          <h2>Consent to Audio Recording</h2>

          <div>
            <b>Principle Investigator</b>: Dr. Prasanta Kumar Ghosh
            <br></br>
            <p style={{ textAlign: "right" }}>
              Department of Electrical Engineering
              <br></br>
              Indian Institute of Science, Bangalore
              <br></br>
            </p>
          </div>

          <div>
            <b>Confidentiality of records</b>: The records of this study will be
            kept confidential. Only the researchers associated with this study
            will be given access to these records.
          </div>

          <div>
            <b>Taking part is voluntary</b>: Taking part in this study is
            completely voluntary. Participants can pause whenever they are tired
            in the long recordings and they are free to leave recording at any
            time for any reason. Even after signing the informed consent form, a
            participant may choose to withdraw from recording.
          </div>

          <div>
            <b>Statement of Consent</b>: I have read the above information. I
            consent to take part in the study
          </div>
        </div>
        <div
          className="flex-container"
          style={{ maxWidth: "30rem", margin: "auto" }}
        >
          <small className="mb-2">
            By clicking proceed, you are agreeing to the above terms and
            conditions
          </small>

          <button
            className="btn btn-dark flex-container"
            onClick={() => this.props.setCurrentPage("meta")}
          >
            Click to Proceed
          </button>
        </div>
      </div>
    );
  }
}

export default TermsPage;
